import { render } from "./PuzzleTypePractice.vue?vue&type=template&id=ab99273c"
import script from "./PuzzleTypePractice.vue?vue&type=script&lang=js"
export * from "./PuzzleTypePractice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__